import http from '../../http'
export default {
    save: params => {
        return http.post("opservice/marketingCampaign/save", params);
      },
    tree: params => {
        return http.get("opservice/corp/getAll", params);
      },
    notify: params => {
        return http.post("opservice/marketingCampaign/ykj/notify", params)
      },
    find: params => {
      return http.post("opservice/marketingCampaign/find",params)
    }
}
